import { Currency, CurrencySelect, UpsellGuard } from '@components'

import { Icon, SkeletonBox } from '@billy/design-system'
import { ReactElement } from 'react'
import { useWindowSize } from 'react-use'

import { Scope } from '../../../../../../../../../../../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../../../../../../../../../../../enums/trackingContext'
import { useInvoiceEditorForm } from '../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import { useInvoiceEditorBaseCurrency } from '../../../../../../../../../../../../hooks/useInvoiceEditorBaseCurrency'
import { useUpdateDependentCurrencies } from '../../../../../../../../hooks/useUpdateDependentCurrencies'
import * as Styled from './styles'

export const InvoiceCurrency = (): ReactElement => {
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()
  const { baseCurrency, isLoading } = useInvoiceEditorBaseCurrency()
  const { handleExchangeRateChange } = useUpdateDependentCurrencies()
  const { width: windowWidth } = useWindowSize()

  const isCompactLayout = windowWidth < 1200
  const { FormItem } = invoiceEditorForm

  if (isLoading) {
    return <SkeletonBox fullHeight fullWidth />
  }

  return (
    <Styled.InvoiceCurrencyFormItemWrapper isCompactLayout={isCompactLayout}>
      <FormItem
        name="currency"
        render={({ field: { value, onChange, ...rest } }) => (
          <UpsellGuard scope={Scope.InvoiceMultiCurrencyUpsell} trackingContext={TrackingContext.InvoiceMultiCurrency}>
            <CurrencySelect
              {...rest}
              onSelect={(_id?: string, value?: Currency) => {
                if (value) {
                  trackInvoiceEditor('Form - Currency dropdown selected', { currency: value.name })
                  onChange(value.id)
                  handleExchangeRateChange(value?.exchangeRate)
                }
              }}
              prefix={isCompactLayout ? null : <Icon icon="coins" />}
              referenceCurrency={baseCurrency}
              selectedId={value}
              size="sm"
            />
          </UpsellGuard>
        )}
      />
    </Styled.InvoiceCurrencyFormItemWrapper>
  )
}
